@let element = elementSg();

@if (element.widget) {
  <atn-mosaic-grid-widget [ref]="element.widget" />
} @else if (element.column) {
  <atn-mosaic-grid-column [column]="element.column" />
} @else if (element.row) {
  <atn-mosaic-grid-row [row]="element.row" />
}
